import { createSlice } from "@reduxjs/toolkit";
import {
  createSec9InterimOrdersAction,
  updateSec9InterimOrdersAction,
  getSec9InterimOrdersByCaseIDAction,
  deleteSec9InterimOrdersAction,
} from "../../actions/Sec9Interimorders/sec9InterimOrdersAction";

const initialState = {
  interimOrders: [],
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

const sec9InterimOrdersSlice = createSlice({
  name: "sec9InterimOrders",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSec9InterimOrdersByCaseIDAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getSec9InterimOrdersByCaseIDAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.interimOrders = action.payload.Sec9InterimOrders || [];
        },
      )
      .addCase(getSec9InterimOrdersByCaseIDAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    // =========================================================================
    // CREATE INTERIM ORDER
    // =========================================================================
    builder
      .addCase(createSec9InterimOrdersAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSec9InterimOrdersAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Interim Order created successfully";
        state.interimOrders.push(action.payload.data);
      })
      .addCase(createSec9InterimOrdersAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // UPDATE INTERIM ORDER
    // =========================================================================
    builder
      .addCase(updateSec9InterimOrdersAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSec9InterimOrdersAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Interim Order updated successfully";

        const index = state.interimOrders.findIndex(
          (o) => o.sec9InterimOrder_ID === action.payload.sec9InterimOrder_ID,
        );

        if (index !== -1) {
          state.interimOrders[index] = action.payload;
        }
      })
      .addCase(updateSec9InterimOrdersAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // DELETE INTERIM ORDER
    // =========================================================================
    builder
      .addCase(deleteSec9InterimOrdersAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSec9InterimOrdersAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Interim Order deleted successfully";

        state.interimOrders = state.interimOrders.filter(
          (o) => o.sec9InterimOrder_ID !== action.payload,
        );
      })
      .addCase(deleteSec9InterimOrdersAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSuccess } = sec9InterimOrdersSlice.actions;

export default sec9InterimOrdersSlice.reducer;
